/**
 * Copyright 2019 Atelier Disko. All rights reserved. This source
 * code is distributed under the terms of the BSD 3-Clause License.
 */

import React, { useState } from 'react';
import './Tabs.css';
import TabBar from '../dpa-TabBar';
import { slugify } from '../utils';

function Tabs(props) {
  const [activeTab, setActiveTab] = useState(undefined);

  let tabs = React.Children.map(props.children, c => {
    return c.props.title;
  });

  let tabToShow;
  React.Children.forEach(props.children, c => {
    if (slugify(c.props.title) === activeTab) {
      tabToShow = c;
    }
  });

  if (!activeTab) {
    tabToShow = props.children[0];
  }

  return (
    <div className="tabs">
      <div className="tabs__tab-bar">
        <TabBar
          onSetActiveTab={a => {
            setActiveTab(slugify(a));
          }}
          activeTab={activeTab}
          tabs={tabs}
        />
      </div>
      <div className="tabs__stage">{tabToShow}</div>
    </div>
  );
}

export default Tabs;

export function Panel(props) {
  return <div className="tabs-panel">{props.children}</div>;
}
